import Repository from './Repository'
const resource = '/bukkens'

export default {
  /**
   * 物件一覧を取得する
   * @param {Object} item 物件検索項目
   * @param {String} type 検索タイプ residence:居住用 investment:事業・投資用
   */
  async get(item, type) {
    const params = { params: item, type: type }
    return await Repository.post(`/query${resource}`, params)
      .then(response => {
        return response.data
      })
      .catch(e => {
        console.log(e)
      })
  },
  /**
   * 物件情報を取得する
   * @param {Number} id 物件ID
   */
  async getOne(id) {
    return await Repository.get(`${resource}/${id}`)
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
  /**
   * 物件情報を登録する
   * @param {Array} property 物件情報
   */
  async post(property) {
    const params = property
    return await Repository.post(`${resource}`, params)
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
  /**
   * 物件情報を更新する
   * @param {Number} id 物件ID
   * @param {Array} property 物件情報
   */
  async put(id, property) {
    const params = property
    return await Repository.put(`${resource}/${id}`, params)
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
  /**
   * 物件情報を削除する
   * @param {Number} id 物件ID
   */
  async delete(id) {
    return await Repository.delete(`${resource}/${id}`)
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
  /**
   * 物件情報を一括削除する
   * @param {Array} ids 物件ID
   */
  async deleteBulk(ids) {
    const params = { b_regular_ids: ids }
    return await Repository.post(`${resource}/bulk_delete`, params)
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
  /**
   * 物件情報をコピーする
   * @param {Number} id 物件ID
   * @param {Number} copyType コピータイプ 1:物件画像を含んでコピー 2:物件画像を含まずコピー（近隣画像はコピー）
   */
  async copy(id, copyType) {
    const params = { b_regular_id: id, copy_type: copyType }
    return await Repository.post(`${resource}/copy`, params)
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
  /**
   * 物件情報をコピーする
   * @param {Array} id コピーID
   */
  async copyConfirm(id) {
    const params = { copy_id: id }
    return await Repository.post(`${resource}/copy_confirm`, params)
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
  /**
   * コンバート一覧を取得する
   * @param {Number} id 物件ID
   */
  async getConvert(id) {
    const params = { b_regular_id: id }
    return await Repository.get(`${resource}/${id}/conv_lists`, { params: params })
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
  /**
   * コンバート情報を更新する
   * @param {Number} id 物件ID
   * @param {Array} shopId 店舗ID
   * @param {Number} portalSite ポータルサイトcd
   * @param {Array} currentState コンバートステータス
   */
  async putConvert(id, shopId, portalSite, currentState) {
    return await Repository.put(
      `${resource}/${id}/conv_lists_by_shop/${shopId}/portalsites/${portalSite}/status/${currentState}`,
    )
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
        throw e
      })
  },
  /**
   * コンバートパノラマ情報を更新する
   * @param {Number} id 物件ID
   * @param {Array} shopId 店舗ID
   * @param {Number} portalSite ポータルサイトcd
   * @param {Array} panoramaFlag パノラマフラグ
   */
  async putConvertPanorama(id, shopId, portalSite, panoramaFlag) {
    return await Repository.put(
      `${resource}/${id}/conv_lists_by_shop/${shopId}/panorama_flags/${portalSite}/flag/${panoramaFlag}`,
    )
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
  /**
   * 物件確認を更新する
   * @param {Number} id 物件ID
   * @param {Array} params 物件確認項目
   */
  async patchHappyCall(id, params) {
    return await Repository.patch(`${resource}/${id}/happycall`, params)
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
  /**
   * 確認日を本日にする
   * @param {Array} ids 物件ID
   */
  async patchConfirmToday(ids) {
    const params = { b_regular_ids: ids }
    return await Repository.patch(`${resource}/confirm_today`, params)
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
  /**
   * 簡易編集を更新する
   * @param {Number} id 物件ID
   * @param {Object} params 簡易編集項目
   */
  async patchQuickEdit(id, params) {
    return await Repository.patch(`${resource}/${id}/quick_edit`, params)
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
  /**
   * ★を更新する
   * @param {Number} id 物件ID
   * @param {String} star ★
   */
  async putListStar(id, star) {
    const params = { list_star: star }
    return await Repository.put(`${resource}/${id}/star`, params)
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
}
